import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import { useTranslation } from '@gem/modules/i18n';

import { UnauthorizedLayout } from 'APP/components/UnauthorizedLayout/UnauthorizedLayout';
import { UnauthorizedLayoutTemplate } from 'APP/components/UnauthorizedLayoutTemplate/UnauthorizedLayoutTemplate';
import { Login } from 'APP/pages/authorization/Login/Login';

import { useCallInvitationLoginPagePresenter } from './CallInvitationLoginPage.presenter';

export const CallInvitationLoginPage: FC = observer(() => {
  const navigate = useNavigate();
  const presenter = useCallInvitationLoginPagePresenter();

  const { t } = useTranslation();

  if (presenter.isAuthenticated && presenter.homePagePath) {
    return (
      <Navigate
        to={presenter.homePagePath}
        replace
      />
    );
  }

  return (
    <UnauthorizedLayout>
      {presenter.isLoggingIn ? (
        <UnauthorizedLayoutTemplate
          title={t('auth_sign_in')}
          isLoading
        />
      ) : (
        <Login onBack={(): void => navigate(-1)} />
      )}
    </UnauthorizedLayout>
  );
});
